import React from 'react';
import moment from 'moment';
import NoDataMsg from 'library/noData';
import DateCurrentDisplay from 'screens/containers/report/DateCurrentDisplay';


const Body = ({ deliveryReport, selectedDate }) => (
    <div>
        { 
            deliveryReport.list && deliveryReport.list.length <= 0 ? 
                //If there's NO DATA to display
                <NoDataMsg />
                :
                //If there's DATA
                deliveryReport.list && deliveryReport.list.length > 0 &&
                <div>
                    <div className="row m-0">
                        <div className="text-center list_header">
                            {selectedDate ?
                               <DateCurrentDisplay />
                                : ""}
                        </div>
                    </div>
                    {
                        deliveryReport.list.map((item, index) => {
                            return (
                                <div className="row m-0 border_bottom_grey pt-2 pb-2 price_info col-4-padding" key={index}>
                                    <div className="col-lg-3 col-md-3 col-sm-3 col-xs-11 m-0 p-0">
                                        <div className="row m-0 p-0">
                                            <div className="col-lg-5 col-md-5 col-sm-5 col-xs-5 m-0 p-0">
                                                <h4>Online Order Code</h4>
                                                <span>{item.orderCode}</span>
                                            </div>
                                            <div className="col-lg-3 col-md-3 col-sm-3 col-xs-4 m-0 p-0">
                                                <h4>Order ID</h4>
                                                <span>{item.generatedOrderId}</span>
                                            </div>
                                            <div className="col-lg-4 col-md-4 col-sm-4 col-xs-3 m-0 p-0">
                                                <h4>Name</h4>
                                                <span>{item.firstName + " " + item.lastName}</span>
                                            </div>
                                        </div>
                                    </div> 

                                    <div className="col-lg-6 col-md-6 col-sm-9 col-xs-12 m-0 p-0">
                                        <div className="row m-0 p-0">
                                            <div className="col-lg-5 col-md-5 col-sm-5 col-xs-5 m-0 p-0">
                                                <h4>Address</h4>
                                                <span>{item.address}</span>
                                            </div>
                                            <div className="col-lg-2 col-md-2 col-sm-1 col-xs-2 m-0 p-0">
                                                <h4>City</h4>
                                                <span>{item.city}</span>
                                            </div>
                                            <div className="col-lg-3 col-md-3 col-sm-3 col-xs-3 m-0 p-0">
                                                <h4>State</h4>
                                                <span>{item.state}</span>
                                            </div>
                                            <div className="col-lg-2 col-md-2 col-sm-2 col-xs-2 m-0 p-0">
                                                <h4>Postal Code</h4>
                                                <span>{item.postalCode}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-3 col-sm-12 col-xs-12 m-0 p-0">
                                        <div className="row m-0 p-0">
                                            <div className="col-lg-0 col-md-0 col-sm-3 col-xs-0 m-0 p-0">
                                                <span></span>
                                            </div>
                                            <div className="col-lg-5 col-md-5 col-sm-4 col-xs-5 m-0 p-0">
                                                <h4>Address 2</h4>
                                                <span>{item.address2}</span>
                                            </div>
                                            <div className="col-lg-3 col-md-3 col-sm-5 col-xs-4 m-0 p-0">
                                                <h4>Phone</h4>
                                                <span>{item.phone}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )
                        })

                    }
                    
                </div>
        }
    </div>
);

export default Body;


